export default __webpack_public_path__ + "static/media/Nadisha Gautam.199e458c.png";